import { Doughnut } from 'react-chartjs-2';
import '../charts/lifecyclecharts.css';
import { BeatLoader } from 'react-spinners';

const ServerStatusChart = ({ data, setIsSwitchOnServerExpired, setIsSwitchOnServerCritical, setIsSwitchOnServerHealthy, averageOperatingDaysServers, loading }) => {

     const renderLoader = () => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'auto' }}>
          <BeatLoader size={8} color="#ccc"/>
        </div>
      );

    const healthy = data.datasets[0].data[0];
    const critical = data.datasets[0].data[1];
    const expired = data.datasets[0].data[2];
    const total = loading ? '⌛' : healthy + critical + expired;

    const handleClick = (event, elements) => {
        if (elements.length > 0) {
            const { index } = elements[0];
            const label = data.labels[index];
            const value = data.datasets[0].data[index];
            console.log(`Label: ${label}, Value: ${value}`);

            if (label === 'Critical') {
                setIsSwitchOnServerExpired(false);
                setIsSwitchOnServerHealthy(false);
                setIsSwitchOnServerCritical(prev => !prev);                
            } else if (label === 'Expired') {
                setIsSwitchOnServerHealthy(false);
                setIsSwitchOnServerCritical(false);
                setIsSwitchOnServerExpired(prev => !prev);
            } else if (label === 'Healthy') {
                setIsSwitchOnServerExpired(false);
                setIsSwitchOnServerCritical(false);
                setIsSwitchOnServerHealthy(prev => !prev);
            }
        }
    };

    return (
    <div className='lifecycle-chart-container'>      
        <div className='lifecycle-legend'>
            <div className='lifecycle-legend-item'>
                { loading ? (
                    renderLoader()
                ) : (
                    <div className='lifecycle-legend-item-value-total'>{total}</div>
                )}
                <div className='lifecycle-legend-item-label'>Healthy</div>    
            </div>               
            <div className='lifecycle-legend-item'>
                { loading ? (
                    renderLoader()
                ) : (
                    <div className='lifecycle-legend-item-value-critical'>{critical}</div>
                )}
                <div className='lifecycle-legend-item-label'>Critical</div>                    
            </div>
            <div className='lifecycle-legend-item'>
                { loading ? (
                    renderLoader()
                ) : (
                    <div className='lifecycle-legend-item-value-expired'>{expired}</div>
                )}
                <div className='lifecycle-legend-item-label'>Expired</div>                    
            </div>
        </div> 
        <div className='center-align-chart'>
            <Doughnut
                data={data}
                options={{
                responsive: true,
                cutout: '71%',
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                    display: false,
                    },
                    tooltip: {
                        callbacks: {
                            label: function (tooltipItem) {
                            const label = data.labels[tooltipItem.dataIndex];
                            const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.dataIndex];
                            return `${label}: ${value}`;
                            },
                        },
                    },                  
                   centerText: {
                    display: true,
                    title: total,                // Top number
                    subtitle: 'Total Servers',  // Bottom label
                    color: '#ffffff',
                    fontSize: 24,
                    fontStyle: 'bold',
                    subtitleFontSize: 14,
                    subtitleFontStyle: 'normal'
                    }
                },
                onClick: (event, elements) => handleClick(event, elements),
                }}

                plugins={[
                {
                    id: 'centerText',
                    beforeDraw: function (chart) {
                    const { width, height, ctx } = chart;
                    const pluginConfig = chart.options.plugins.centerText;

                    if (!pluginConfig?.display) return;

                    ctx.save();

                    // Calculate center
                    const centerX = width / 2;
                    const centerY = height / 2;

                    // Draw top line (title)
                    ctx.font = `${pluginConfig.fontStyle || 'bold'} ${pluginConfig.fontSize || 24}px sans-serif`;
                    ctx.fillStyle = pluginConfig.color || '#333';
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText(pluginConfig.title, centerX, centerY - 10);

                    // Draw bottom line (subtitle)
                    ctx.font = `${pluginConfig.subtitleFontStyle || 'normal'} ${pluginConfig.subtitleFontSize || 14}px sans-serif`;
                    ctx.fillText(pluginConfig.subtitle, centerX, centerY + 14);

                    ctx.restore();
                    }
                }
                ]}
            />
        </div>        
    </div>
)};

export default ServerStatusChart;
